import MimiroPrivacyPolicy from './mimiro-privacy-policy';
export default MimiroPrivacyPolicy;
